<!-- 支付页 -->
<template>
  <div class="page">
    <!-- <LNavbar /> -->
    <div class="nav-header">
      <div class="empty"></div>
      <div class="logo">
        <img src="/imgs/logo.png" alt="logo" />
      </div>
      <div class="close">
        <img src="/imgs/close.png" alt="close" @click="back" />
      </div>
    </div>
    <Nuxt />
    <Lfooter />
  </div>
</template>

<script>
import Lfooter from '@/components/Lfooter/index.vue'
export default {
  name: 'paymentPage',
  components: {
    Lfooter
  },
  scrollToTop: true,
  data() {
    return {}
  },
  methods: {
    back() {
      this.$router.back()
      // this.$confirm({ msg: 'Do you want to exit the lenses choosing process?' }).then(res => {
      //   if (res === 'success') {
      //     this.$router.back()
      //   }
      // })
    }
  }
}
</script>
<style lang="scss" scoped>
$headerHeight: 60px;
.page {
  height: 100%;
  position: relative;
  background: #f7f7f7;
  ::v-deep .payment-body {
    margin-top: $headerHeight;
  }
}
.nav-header {
  position: fixed;
  top: 0;
  z-index: 2;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 40px;
  height: $headerHeight;
  background: #ffffff;
  // border-bottom: 1px solid #e4e4e4;
}
.logo,
.close {
  display: flex;
  img {
    height: 100%;
    // width: 100%;
  }
}
.logo {
  height: 40px;
}
.close {
  height: 18px;
  cursor: pointer;
}
</style>
<style scoped lang="scss">
@media screen and (max-width: 768px) {
  $headerHeight: 46px;
  .page {
    ::v-deep .payment-body {
      margin-top: $headerHeight;
    }
  }
  .nav-header {
    padding: 0 16px;
    height: $headerHeight;
  }
  .logo {
    height: 28px;
  }
  .close {
    height: 14px;
  }
}
</style>
